import { fetchGET } from "../utils/handler_http";

/**
 * Obtener la lista de viajes
 */
export const getListTrips = async (jwt = "") => {
  const response = await fetchGET(
    process.env.REACT_APP_TRIPS_LIST_ENDPOINT,
    {},
    { Authorization: jwt }
  );
  return response;
};

/**
 * Obtener la auditoría de despacho de un viaje específico
 * (conductores cercanos al momento de la solicitud)
 */
export const getDispatchAudit = async (tripId = 0, jwt = "") => {
  const endpoint =
    process.env.REACT_APP_DISPATCH_AUDIT_ENDPOINT ||
    (process.env.REACT_APP_ADMIN_ENDPOINT
      ? process.env.REACT_APP_ADMIN_ENDPOINT.replace(
          /\/admin$/,
          "/admin-read-dispatch-audit"
        )
      : "");
  return fetchGET(
    endpoint,
    { tripId },
    { Authorization: jwt },
  );
};

/**
 * Obtener los logs de ubicación (ruta real) de un viaje específico
 */
export const getTripLocationLogs = async (tripId = 0, jwt = "") => {
  const endpoint =
    process.env.REACT_APP_TRIP_LOCATION_LOGS_ENDPOINT ||
    (process.env.REACT_APP_ADMIN_ENDPOINT
      ? process.env.REACT_APP_ADMIN_ENDPOINT.replace(
          /\/admin$/,
          "/admin/trip-location-logs"
        )
      : "");
  return fetchGET(
    endpoint,
    { tripId },
    { Authorization: jwt },
  );
};

